module.exports = {"370686001":"翠屏街道","370686002":"庄园街道","370686003":"松山街道","370686101":"观里镇","370686102":"蛇窝泊镇","370686103":"唐家泊镇","370686104":"桃村镇","370686105":"亭口镇","370686106":"臧家庄镇","370686107":"寺口镇","370686108":"苏家店镇","370686109":"杨础镇","370686110":"西城镇","370686111":"官道镇","370686113":"庙后镇","370686401":"山东栖霞经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370686.json
// module id = 1300
// module chunks = 0